let conceptMappingData: any = [];
let chapterMappingData: any = [];
export const conceptMapping = (treeData: any, handleSetState: Function) => {
    const { phases = [] } = treeData;
    phases.forEach((phase: any, indexOfPhases: number) => {
        const { weeks = [] } = phase;
        weeks.forEach((week: any, indexOfWeeks: number) => {
            const { subjects = [] } = week;
            subjects.forEach((subject: any, indexOfSubject: number) => {
                const { chapters = [] } = subject;
                chapters.forEach((chapter: any, indexOfChapter: number) => {
                    const { concepts = [] } = chapter;
                    let chapterAddress = {
                        masterId: chapter.id,
                        phaseIndex: indexOfPhases,
                        weekIndex: indexOfWeeks,
                        subjectIndex: indexOfSubject,
                        chapterIndex: indexOfChapter,
                    }
                    chapterMappingData.push(chapterAddress);
                    concepts.forEach((concept: any, indexOfConcept: number) => {
                        let conceptAddress = {
                            masterId: concept.id,
                            phaseIndex: indexOfPhases,
                            weekIndex: indexOfWeeks,
                            subjectIndex: indexOfSubject,
                            chapterIndex: indexOfChapter,
                            conceptIndex: indexOfConcept
                        }
                        conceptMappingData.push(conceptAddress);
                    })
                })
            })
        });
    });
    handleSetState({
        mappedConceptsAndChapter: {
            chapterAddress: chapterMappingData,
            conceptAddress: conceptMappingData
        }
    });
}

export const  mappingWithHash = (treeData: any, handleSetState: Function) => {
    const { phases = [] } = treeData;
    const allDataMap = new Map();
    // const conceptMap = new Map();
    phases.forEach((phase: any, indexOfPhases: number) => {
        const { weeks = [] } = phase;
        weeks.forEach((week: any, indexOfWeeks: number) => {
            const { subjects = [] } = week;
            subjects.forEach((subject: any, indexOfSubject: number) => {
                const { chapters = [] } = subject;
                chapters.forEach((chapter: any, indexOfChapter: number) => {
                    const { concepts = [] } = chapter;
                    // let chapterAddress = {
                    //     masterId: chapter.id,
                    //     phaseIndex: indexOfPhases,
                    //     weekIndex: indexOfWeeks,
                    //     subjectIndex: indexOfSubject,
                    //     chapterIndex: indexOfChapter,
                    // }
                    allDataMap.set(chapter.id, {
                        phaseIndex: indexOfPhases,
                        weekIndex: indexOfWeeks,
                        subjectIndex: indexOfSubject,
                        chapterIndex: indexOfChapter,
                     })
                    // chapterMappingData.push(chapterAddress);
                    concepts.forEach((concept: any, indexOfConcept: number) => {
                        // let conceptAddress = {
                        //     masterId: concept.id,
                        //     phaseIndex: indexOfPhases,
                        //     weekIndex: indexOfWeeks,
                        //     subjectIndex: indexOfSubject,
                        //     chapterIndex: indexOfChapter,
                        //     conceptIndex: indexOfConcept
                        // }
                        allDataMap.set(concept.id, {
                            phaseIndex: indexOfPhases,
                            weekIndex: indexOfWeeks,
                            subjectIndex: indexOfSubject,
                            chapterIndex: indexOfChapter,
                            conceptIndex: indexOfConcept
                         })
                        // conceptMappingData.push(conceptAddress);
                    })
                })
            })
        });
    });
    handleSetState({
        mappedConceptsAndChapter: allDataMap
    });

}